import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ApiError } from '../api/api-error';
import { BranchApi } from '../api/branch.api';
import { mapBranch, mapBranches } from '../mappers/branch.mapper';
import type { GeoPoint } from '../models/address/address.model';
import type { Branch } from '../models/branch/branch.model';
import type { ApiEnvelope } from './api-envelope';
import { apiPath, mapApiError, unwrapEnvelope } from './api-envelope';

@Injectable()
export class BranchHttpApi extends BranchApi {
  private readonly http = inject(HttpClient);

  override closest(point: GeoPoint): Observable<Branch> {
    return this.http
      .get<ApiEnvelope<unknown> | null>(apiPath('/api/users/client/closest'), {
        params: pointParams(point),
      })
      .pipe(unwrapEnvelope<unknown>(), map(readBranch), mapApiError());
  }

  override nearby(point: GeoPoint): Observable<Branch[]> {
    return this.http
      .get<ApiEnvelope<unknown> | null>(apiPath('/api/users/client/branch/nearby'), {
        params: pointParams(point),
      })
      .pipe(unwrapEnvelope<unknown>(), map(mapBranches), mapApiError());
  }

  override list(): Observable<Branch[]> {
    // Координаты в query бэкенд игнорирует и `distanceKm` в списке не шлёт — сортировать нечем.
    return this.http
      .get<ApiEnvelope<unknown> | null>(apiPath('/api/users/client/branch'))
      .pipe(unwrapEnvelope<unknown>(), map(mapBranches), mapApiError());
  }
}

function pointParams(point: GeoPoint): HttpParams {
  return new HttpParams().set('latitude', point.latitude).set('longitude', point.longitude);
}

/** Непригодный ответ равен отсутствию филиала: самовывоз без валидного `branchId` не оформить. */
function readBranch(raw: unknown): Branch {
  const branch = mapBranch(raw);
  if (branch === null) {
    throw new ApiError(404, 'branch_not_found');
  }
  return branch;
}
